import { mixHermite } from "@thi.ng/math";
import { interpolate } from "./interpolate";
export function interpolateHermite(n, src) {
    return interpolate((chunk, t) => mixHermite(...chunk, t), 4, n, src);
}
